import { COLORS } from "./colors";
import { STRINGS } from "./strings";
import {
  faCheckCircle,
  faHourglassHalf,
  faSmile,
  faThumbsUp,
  faGem,
  faCircle,
  faSquare,
  faTree,
  faRoad,
  faLeaf,
  faMountain,
  faHardHat,
  faTh,
  faHome,
  faWalking,
  faBan,
  faRoute,
  faStarHalfStroke,
  faRedo,
  faList,
  faFilter,
  faMap,
} from "@fortawesome/free-solid-svg-icons";

import softtrail from "../assets/imgs/softtrail.svg";
import neighborhoodconnection from "../assets/imgs/neighborhoodconnection.svg";
import sharedusepath from "../assets/imgs/sharedusepath.svg";
import parkpath from "../assets/imgs/parkpath.svg";
import sidepath from "../assets/imgs/sidepath.svg";
import hiking from "../assets/imgs/hiking.svg";
import MapMarker from "../assets/imgs/point.android.png";
import SelectedMapMarker from "../assets/imgs/pointSelected.android.png";
import { isMobileWeb } from "../utils/utility";

export const difficultyStyles = {
  Easiest: {
    backgroundColor: COLORS.easyBackground,
    borderColor: COLORS.easy,
    color: COLORS.easy,
  },
  Easy: {
    backgroundColor: COLORS.easyBackground,
    borderColor: COLORS.easy,
    color: COLORS.easy,
  },
  Moderate: {
    backgroundColor: COLORS.moderateBackground,
    borderColor: COLORS.moderate,
    color: COLORS.moderate,
  },
  Difficult: {
    backgroundColor: COLORS.difficultBackground,
    borderColor: COLORS.difficult,
    color: COLORS.difficult,
  },
  "Black Diamond": {
    backgroundColor: COLORS.descriptionText,
    borderColor: COLORS.descriptionText,
    color: COLORS.textLight,
    filterColor: COLORS.textDark || COLORS.primary,
  },
  "Green Circle": {
    backgroundColor: COLORS.greenBackground || COLORS.backgroundColor,
    borderColor: COLORS.green || COLORS.descriptionText,
    color: COLORS.green || COLORS.textDark,
  },
  "Blue Square": {
    backgroundColor: COLORS.blueBackground || COLORS.backgroundColor,
    borderColor: COLORS.blue || COLORS.descriptionText,
    color: COLORS.blue || COLORS.textDark,
  },
  null: {
    backgroundColor: COLORS.backgroundColor,
    borderColor: COLORS.border,
    color: COLORS.descriptionText,
  },
};

export const descriptionIcons = {
  "Soft Trail": faTree,
  "Neighborhood Connection": faHome,
  "Shared Use Path": faWalking,
  "Park Path": faLeaf,
  Sidepath: faRoad,
  Active: faCheckCircle,
  Pending: faHourglassHalf,
  Easiest: faSmile,
  Easy: faThumbsUp,
  Moderate: faStarHalfStroke,
  "Black Diamond": faGem,
  "Green Circle": faCircle,
  "Blue Square": faSquare,
  "City Park": faTree,
  Asphalt: faRoad,
  Wood: faTree,
  Natural: faLeaf,
  "Stone Dust": faMountain,
  Concrete: faHardHat,
  Gravel: faMountain,
  Pavers: faTh,
  "OFF ROAD": faMountain,
  "ON ROAD": faRoad,
  "Data Unavailable": faBan,
  route: faRoute,
  Reset: faRedo,
  "Discover Trails": faList,
  Filter: faFilter,
  Map: faMap,
};

export const labelDescriptions = {
  "Shared Use Path":
    "Typically 11 feet wide or more, offer a buffer from traffic and are designed for safe passing by both pedestrians and bicyclists.",
  "Soft Trail": "Unpaved nature trails, ideal for hiking or running, offering a rustic outdoor experience.",
  Sidepath:
    "A multi-use trail parallel to a roadway, offering a safe, accessible space for pedestrians and cyclists, typically wider than a sidewalk. ",
  "Neighborhood Connection": "Paths located within parks that usually connect separated streets or neighborhoods.",
  "Park Path":
    "Park trails, located within parks, come in various surfaces, making them great for all kinds of outdoor activities.",
  Active: "This trail is available for public use!",
  Pending: "This trail is in the works and not available for public use.",
  Easiest: "A flat, well-maintained path ideal for beginners and casual walkers.",
  Easy: "A path with mild terrain and traffic, suitable for most hikers as well as casual walkers and bikers.",
  "Black Diamond":
    "The trail is very difficult, allows only one-way travel, and includes optional terrain features for advanced riders.",
  "Green Circle": "The trail offers easy riding, allows travel in both directions, and features bridges along the way.",
  "Blue Square":
    "The trail is more challenging, allows only one-way travel, with optional terrain features for added difficulty.",
  // Descriptions generated from copilot START
  "City Park":
    "Trails located within urban parks, often well-maintained and suitable for families or casual strolls. They may include amenities like benches, fountains, and playgrounds.",
  Asphalt:
    "Smooth, paved trails ideal for biking and running with good traction. They tend to be easy to navigate and are commonly found in urban areas.",
  Wood: "Trails that are often made from wooden planks or boardwalks, providing a safe and stable surface over soft ground or marshy areas. They blend into natural surroundings with minimal environmental impact.",
  Natural:
    "Unpaved trails that follow the natural landscape, featuring dirt, grass, or natural terrain. These trails often provide a more immersive nature experience, but may vary in difficulty.",
  "Stone Dust":
    "Typically composed of finely crushed stone, these trails are solid yet permeable, allowing for good drainage. They offer a firm surface for biking and hiking, combining durability with a natural feel.",
  Concrete:
    "Highly durable and smooth surfaces, suitable for a variety of activities. Concrete trails are low maintenance and can withstand heavy usage, often found in urban settings.",
  Gravel:
    "Composed of loose stones, gravel trails provide a rugged experience. They can be more challenging to navigate but are often favored for mountain biking or hiking in remote areas.",
  Pavers:
    "Trails made with interlocking bricks or tiles, providing a stable and aesthetically pleasing surface. These trails are often used in parks and recreational areas.",
  "OFF ROAD":
    "Trails specifically designed for mountain biking or rugged hiking, featuring uneven terrain, obstacles, and natural challenges. They are suited for more experienced outdoor enthusiasts seeking adventure.",
  "ON ROAD":
    "Designed for biking on public roads, these trails may include bike lanes or shared shoulders. They allow cyclists to travel between urban destinations or enjoy scenic routes while riding alongside vehicles.",
  // Descriptions generated from copilot END :
  Moderate: "A trail with some challenging terrain, suitable for experienced hikers and bikers.",
  Reset: "Resets the map to the default position.",
  "Discover Trails": "Shows a list of trails.",
  "Map marker": "Shows an unselected trail location.",
  "Map marker selected": "Shows a selected trail location.",
  Map: "Opens the map page.",
  "Data Unavailable": "No data is was found.",
  "Route Name": "The name of the trail.",
  "City Trails": "Toggle to show or hide city trails.",
  "State Trails": "Toggle to show or hide state trails.",
};

export const iconMap = {
  "Soft Trail": softtrail,
  "Neighborhood Connection": neighborhoodconnection,
  "Shared Use Path": sharedusepath,
  "Park Path": parkpath,
  Sidepath: sidepath,
  Hiking: hiking,
};

export const defaultfilterValues = {
  facility_type: ["Shared Use Path", "Soft Trail"],
};

export const mapBoundValues = {
  bounds: {
    south: 36.507674895913915,
    west: -76.40518556642692,
    north: 36.95726999716212,
    east: -75.66910158205192,
  },
  zoom: 11,
};

export const mapRestrictions = {
  latLngBounds: {
    north: 37.2882274208564, // Further extended north
    south: 36.18551943714664, // Further extended south
    west: -77.1879223690835, // Further extended west
    east: -75.32848633392724, // Further extended east
  },
  strictBounds: false, // Allow slight movement outside bounds
};

export const initialMapSettings = isMobileWeb()
  ? {
      center: {
        lat: 36.75,
        lng: -76,
      },
      zoom: 10,
    }
  : {
      center: {
        lat: 36.75,
        lng: -76.035,
      },
      zoom: 11,
    };

export const attributes = ["facility_type", "status", "difficulty", "property_type", "surface", "category"];

const filterLegend = {
  name: STRINGS.filter,
  icon: descriptionIcons[STRINGS.filter],
  color: COLORS.primary,
  description: "Opens filter options.",
};

export const legendItems = {
  Map: [
    {
      name: STRINGS.stateTrails,
      description: labelDescriptions[STRINGS.stateTrails],
    },
    {
      name: STRINGS.cityTrails,
      description: labelDescriptions[STRINGS.cityTrails],
    },
    {
      name: STRINGS.reset,
      icon: descriptionIcons[STRINGS.reset],
      color: COLORS.textDark,
      description: labelDescriptions[STRINGS.reset],
    },
    {
      name: STRINGS.listViewTitle,
      icon: descriptionIcons[STRINGS.listViewTitle],
      color: COLORS.textDark,
      description: labelDescriptions[STRINGS.listViewTitle],
    },
    {
      name: STRINGS.mapMarker,
      icon: MapMarker,
      description: labelDescriptions[STRINGS.mapMarker],
    },
    {
      name: STRINGS.mapMarkerSelected,
      icon: SelectedMapMarker,
      description: labelDescriptions[STRINGS.mapMarkerSelected],
    },
    filterLegend,
  ],
  "Discover Trails": [
    {
      name: STRINGS.mapViewTitle,
      icon: descriptionIcons[STRINGS.mapViewTitle],
      color: COLORS.textDark,
      description: labelDescriptions[STRINGS.mapViewTitle],
    },
    {
      name: STRINGS.dataUnavailable,
      icon: descriptionIcons[STRINGS.dataUnavailable],
      color: COLORS.textDark,
      description: labelDescriptions[STRINGS.dataUnavailable],
    },
    filterLegend,
    {
      name: STRINGS.moderate,
      icon: descriptionIcons[STRINGS.moderate],
      color: COLORS.moderate,
      description: labelDescriptions[STRINGS.moderate],
    },
  ],
  "Trail Details": [
    {
      name: STRINGS.routeName,
      icon: descriptionIcons["route"],
      color: COLORS.primary,
      description: labelDescriptions[STRINGS.routeName],
    },
  ],
};

export const stateTrailsUnique = [
  "Bald Cypress Trail",
  "Kingfisher Trail",
  "Fox Run Trail",
  "White Hill Lake Trail",
  "High Dune Trail",
  "Cape Henry Trail",
  "Long Creek Trail",
  "Live Oak Trail",
  "Osmanthus Trail",
  "Sand Ridge Trail",
  "Dudley Island Loop Trail",
  "Wash Woods Trail",
  "Vir-Mar Trail",
  "False Cape Landing Trail",
  "Sandy Point Trail",
  "Maritime Trail",
  "Cemetery Trail",
  "Sundew Trail",
  "Maple Leaf Trail",
  "Bufflehead Overlook Connector Trail",
  "Pintain Overlook Connector Trail",
  "Gadwall Overlook Connector Trail",
  "Wood Duck Overlook Connector Trail",
  "Widgeon Overlook Connector Trail",
  "Tundra Swan Overlook Connector Trail",
  "Barbour Hill Trail",
  "Marsh Ridge Trail",
  "Ocean Pearl Trail",
  "Teal Overlook Connector Trail",
  "South Inlet Trail",
  "Monument Trail",
];
